<mat-error class="mat-error-serial-problem">
  <div>{{ 'captive.form.my-device.registering-serial-problem' | translate }}</div>
  <div>
    {{ 'captive.form.my-device.serial-problem-form-text1' | translate }}
    <a class="mat-error-serial__link" [href]="serialProblemFormLinkKey | translate" target="_blank">
      {{ 'captive.form.my-device.serial-problem-form-text-link' | translate }}
    </a>
    {{ 'captive.form.my-device.serial-problem-form-text2' | translate }}
  </div>
</mat-error>
